import * as React from 'react';
import { Dispatch } from 'redux';
import * as actions from './redux-objects/actions';
import { connect } from 'react-redux';
import './qnot.css';
import DataTable from '../DataTable';
import moment from 'moment';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from 'react-dates';
import LookupValueSelectList from '../LookupValueSelectList/LookupValueSelectList';
import { LookupValueTypes } from '../LookupValueSelectList/lookupValueTypes';
import { INotification, NotificationStatus } from '../../common/sharedTypes';
import { GetURIByParts } from '../../services/Utils/StringUtils';
import Api from '../../services/Api';
import { ApiResponse } from 'apisauce';

const $ = require('jquery');

export interface ISentNotificationsStateProps {
  notifications: INotification[];
  webServiceURL: string;
}

export interface ISentNotificationsActionProps {
  onGetSentNotifications?: (notificaitons: INotification[]) => void;
}

interface ISentNotificationsProps
  extends ISentNotificationsStateProps,
    ISentNotificationsActionProps {}

const initialState = {
  userOnly: true,
  startDate: moment(
    moment().startOf('month').format('DD/MM/YYYY'),
    'DD/MM/YYYY'
  ), // moment('1/2/2019', 'DD/MM/YYYY'),
  endDate: moment(moment().endOf('month').format('DD/MM/YYYY'), 'DD/MM/YYYY'), //moment('28/2/2019', 'DD/MM/YYYY'),
  notificationTypeId: '-1',
  reportTypeId: '-1',
  focusedInput: null,
  statusId: '3',
};
type SentNotificationState = Readonly<typeof initialState>;

enum ServiceEndPoints {
  GetNotifications = 'GetNotifications',
}

class SentNotifications extends React.Component<
  ISentNotificationsProps,
  SentNotificationState
> {
  public constructor(props: ISentNotificationsProps) {
    super(props);
    this.state = initialState;
  }
  private notificationServiceController: string = 'Notification';
  componentDidMount() {
    this.populateNotifications();
  }

  handleUserCheck(userChecked) {
    this.setState({ userOnly: userChecked }, () => {
      this.populateNotifications();
    });
  }

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      this.setState({ startDate, endDate }, () => {
        this.populateNotifications();
      });
    }
  }

  handleNotificationTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    this.setState({ notificationTypeId: value }, () => {
      this.populateNotifications();
    });
  }

  handleReportTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    this.setState({ reportTypeId: value }, () => {
      this.populateNotifications();
    });
  }

  handleStatusTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    this.setState({ statusId: value }, () => {
      this.populateNotifications();
    });
  }

  populateNotifications() {
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.notificationServiceController,
      ServiceEndPoints.GetNotifications
    );

    var params = {
      userOnly: this.state.userOnly,
      startDate: this.state.startDate.toDate().toUTCString(),
      endDate: this.state.endDate.toDate().toUTCString(),
      notificationTypeId: this.state.notificationTypeId,
      reportTypeId: this.state.reportTypeId,
      statusId: this.state.statusId,
      reportsOnly: 'true',
    };

    var esc = encodeURIComponent;
    var query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;
    Api.get(uri)
      //.then((res: ApiResponse<any>))
      .then((result: ApiResponse<any>) => {
        this.props.onGetSentNotifications(result.data);
      });
  }

  public render() {
    const columnDefs = [
      // {
      //   targets: 1,
      //   render: function(data) {
      //     return moment(data).format('MMMM Do YYYY');
      //   }
      // }
    ];

    const columns = [
      {
        title: 'Date Sent/Printed',
        mData: function (data, type, dataToSet) {
          return moment(data.sentDate).format('MMMM Do YYYY');
        },
      },
      {
        title: 'Letter Method',
        data: 'notificationType.name',
      },
      {
        title: 'Send To',
        data: 'sendTo',
      },
      {
        title: 'Sent By',
        mData: function (data, type, dataToSet) {
          return (
            data.createdByUser.firstName + ' ' + data.createdByUser.lastName
          );
        },
      },
      {
        title: 'Subject',
        data: 'subject',
      },
      {
        title: 'Letter Type',
        data: 'notificationTemplate.name',
      },
    ];

    const options = {
      className: 'table table-striped table-bordered',
    };

    return (
      <div className='app'>
        <h3>Sent Letters</h3>
        <hr />
        <Form>
          <Form.Group controlId='formBasicChecbox'>
            <Form.Check
              id='chkSentOnlyICreated'
              type='checkbox'
              label=' Show only Letters I created'
              defaultChecked
              onChange={(e) => this.handleUserCheck(e.target.checked)}
            />
          </Form.Group>
          <Form.Row>
            <Form.Group as={Col} controlId='sentNotificationsStartDate'>
              <Form.Label>Created Date</Form.Label>
              <br />
              <DateRangePicker
                startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                startDateId='sentNotificationsStartDate' // PropTypes.string.isRequired,
                endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                endDateId='sentNotificationsEndDate' // PropTypes.string.isRequired,
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                } // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                } // PropTypes.func.isRequired,
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
            </Form.Group>

            <Form.Group as={Col} controlId='exampleForm.ControlSelect1'>
              <Form.Label>Letter Type</Form.Label>
              <LookupValueSelectList
                onChange={(e) => this.handleNotificationTypeChange(e)}
                value={this.state.notificationTypeId}
                type={LookupValueTypes.NOTIFICATION_TYPES}
                includeAll={true}
              />
            </Form.Group>
            <Form.Group as={Col} controlId='exampleForm.ControlSelect2'>
              <Form.Label>Report Type</Form.Label>
              <LookupValueSelectList
                onChange={(e) => this.handleReportTypeChange(e)}
                value={this.state.reportTypeId}
                type={LookupValueTypes.REPORT_TYPES}
                includeAll={true}
              />
            </Form.Group>
            <Form.Group as={Col} controlId='exampleForm.ControlSelect3'>
              <Form.Label>Status</Form.Label>
              <LookupValueSelectList
                onChange={(e) => this.handleStatusTypeChange(e)}
                value={this.state.statusId}
                type={LookupValueTypes.NOTIFICATION_STATUS_TYPES}
                exclude={['queued']}
                includeAll={false}
              />
            </Form.Group>
          </Form.Row>
        </Form>
        <DataTable
          id='tblSentNotifications'
          data={this.props.notifications}
          columns={columns}
          columnDefs={columnDefs}
          {...options}
        />
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    notifications: state.qnotification.sentNotifications,
    webServiceURL: state.Application.backendURL,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    onGetSentNotifications: (notificaitons: INotification[]) =>
      dispatch(actions.getSentNotifications(notificaitons)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SentNotifications);
